import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InputValidators {

  static isShowOverLengthMsg(control: AbstractControl | null, submitted: boolean, maxLength: any, form: FormGroup): boolean {

    if (isNullOrEmpty(control)) {
      return false;
    }

    var showLengthOverMsg = false;

    form.markAllAsTouched();

    const ctrl = control as AbstractControl;
    var ctrlVal = ctrl.value;
    var catlLength = 0;

    if (!isNullOrEmpty(ctrlVal)) {
      catlLength = new Blob([ctrlVal]).size
    }

    if (catlLength > maxLength) {
      showLengthOverMsg = true;
    } else {
      showLengthOverMsg = false;
    }

    return showLengthOverMsg && (submitted || ctrl.touched);
  }
}
